import { render, staticRenderFns } from "./CampaignTypeCard.vue?vue&type=template&id=33653d08&scoped=true&"
import script from "./CampaignTypeCard.vue?vue&type=script&lang=js&"
export * from "./CampaignTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTypeCard.vue?vue&type=style&index=0&id=33653d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33653d08",
  null
  
)

export default component.exports